/* @flow */
import * as React from 'react';
import { Link } from 'react-router-dom';

import StatusIndicator from 'components/StatusIndicator/StatusIndicator';
import * as emailDomainsPermissions from 'permissions/emailDomains';
import * as accountPermissions from 'permissions/account';
import ManageUserLoginView from 'components/ManageUserLoginView/ManageUserLoginView';

import createReportView from '../components/ReportView/ReportViewBase';
import type { ViewConfig, DataViewColumn } from '../components/ReportView/types';

const columns: DataViewColumn[] = [
  {
    columnName: 'first_name',
    title: 'general:labels.first_name',
    flexBasis: 160,
    component: function FirstName({ display, rowData }) {
      return <Link to={`/users/profile/${rowData.id}`}>{display}</Link>;
    },
  },
  {
    columnName: 'last_name',
    title: 'general:labels.last_name',
    flexBasis: 160,
    component: function LastName({ display, rowData }) {
      return <Link to={`/users/profile/${rowData.id}`}>{display}</Link>;
    },
  },
  {
    columnName: 'email',
    title: 'general:email',
    flexBasis: 200,
  },
  {
    columnName: 'company_name',
    title: 'general:company',
    flexBasis: 200,
  },
  {
    columnName: 'role_id',
    title: 'general:role',
    flexBasis: 200,
    component: ({ rowData, t }) => t(`general:roles.${rowData.role_id}`),
  },
  {
    columnName: 'created_at',
    title: 'general:users.labels.created_date',
    flexBasis: 200,
  },
  {
    columnName: 'latest_login_date',
    title: 'general:users.labels.last_login_date',
    flexBasis: 200,
  },
  {
    columnName: 'admin_name',
    title: 'general:users.labels.impersonated_by',
    flexBasis: 200,
  },
  {
    columnName: 'latest_impersonate_login_date',
    title: 'general:users.labels.impersonated_date',
    flexBasis: 200,
  },
  {
    columnName: 'is_enabled',
    title: 'general:users.labels.status',
    flexBasis: 160,
    disableSort: true,
    component: function UserStatus({ display }) {
      return <StatusIndicator status={display} />;
    },
  },
  {
    columnName: 'id',
    title: '',
    flexBasis: 150,
    disableSort: true,
    component: function ViewAs({ display }) {
      return <ManageUserLoginView action="view" id={display} />;
    },
  },
  {
    columnName: 'id',
    title: '',
    flexBasis: 150,
    disableSort: true,
    component: function LoginAs({ display }) {
      return <ManageUserLoginView action="login" id={display} />;
    },
  },
];

const viewConfig: ViewConfig = {
  title: 'general:user_management',
  codename: 'users',
  type: 'TABBED',
  userFilterNamespace: 'Users',
  defaultTab: 'customer',
  views: {
    internal: {
      title: 'general:role_categories.internal_user_plural',
      dataPathname: 'users-management/internal',
      apiType: 'SQL',
      filtersPathnameOverride: 'users/filters',
      columns,
    },
    customer: {
      title: 'general:role_categories.customer_user_plural',
      dataPathname: 'users-management/customer',
      apiType: 'SQL',
      filtersPathnameOverride: 'users/filters',
      columns,
    },
  },
  buttons: [
    {
      label: 'general:labels.manage_email_domains',
      to: '/email-domains',
      icon: '#icon-email-symbol',
      permissions: emailDomainsPermissions.read,
    },
    {
      label: 'general:actions.new',
      icon: '#icon-add',
      to: '/users/invite',
      permissions: accountPermissions.createInviteUser,
    },
  ],
};

export default createReportView(viewConfig);
